// Deep-linking via the URL hash (build-brief §7.4). No router — ZTX is one
// screen — and the hash (not query) keeps it GitHub-Pages friendly (never hits
// the server). A view is shareable and survives reload:
//   #framework=nist-800-53-r5&domain=NETWORK&control=AC-3
//   #framework=nist-800-53-r5&domain=IDENTITY&ttp=T1110

export interface DeepLinkState {
  frameworkId?: string;
  domain?: string;
  control?: string;
  ttp?: string;
}

const KEYS: Array<keyof DeepLinkState> = ['frameworkId', 'domain', 'control', 'ttp'];
// URL param names (frameworkId → framework).
const PARAM: Record<keyof DeepLinkState, string> = {
  frameworkId: 'framework',
  domain: 'domain',
  control: 'control',
  ttp: 'ttp',
};

export function readDeepLink(): DeepLinkState {
  if (typeof window === 'undefined') return {};
  const hash = window.location.hash.replace(/^#/, '');
  const params = new URLSearchParams(hash);
  const state: DeepLinkState = {};
  for (const key of KEYS) {
    const v = params.get(PARAM[key]);
    if (v) state[key] = v;
  }
  return state;
}

export function writeDeepLink(state: DeepLinkState): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams();
  for (const key of KEYS) {
    const v = state[key];
    if (v) params.set(PARAM[key], v);
  }
  const hash = params.toString();
  const url = `${window.location.pathname}${window.location.search}${hash ? `#${hash}` : ''}`;
  // replaceState (not push) — selection changes shouldn't spam browser history.
  window.history.replaceState(null, '', url);
}
